var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.verificaPerfil('pj'))?_c('dashboard-pessoa-juridica'):_vm._e(),(_vm.verificaPerfil('pf'))?_c('dashboard-pessoa-fisica'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }